var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"8","fill":"transparent","key":0}),React.createElement("path",{"className":"st1","d":"M9,0C4,0,0,4,0,9s4,9,9,9s9-4,9-9S14,0,9,0z M12.3,9.7l-4.2,4.2c-0.4,0.4-0.9,0.3-1.3,0c-0.4-0.4-0.3-0.9,0-1.3\n\tL10.4,9L6.9,5.4c-0.4-0.4-0.3-0.9,0-1.3c0.4-0.4,0.9-0.3,1.3,0l4.2,4.2c0.2,0.2,0.3,0.4,0.3,0.6C12.6,9.3,12.5,9.5,12.3,9.7z","key":1})]);
}

ArrowRight.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 18 18","style":{"enableBackground":"new 0 0 18 18"},"xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
